import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatButtonModule, MatCheckboxModule, MatDialogModule, MatIconModule, MatInputModule, MatRadioModule, MatSelectModule, MatTabsModule, MatTooltipModule } from '@angular/material';
import { EditAuditPictureItemDialogComponent } from './edit-audit-picture-item-dialog.component';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { ModalGalleryModule } from '@ks89/angular-modal-gallery';
import { DeleteDialogModule } from '../edit-audit-item-dialog/deleted-dialog/delete-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DeleteDialogModule,

    ModalGalleryModule.forRoot()
  ],
  declarations: [EditAuditPictureItemDialogComponent],
  entryComponents: [EditAuditPictureItemDialogComponent],
  exports: [EditAuditPictureItemDialogComponent]
})

export class EditAuditPictureItemDialogModule {}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/edit-audit-picture-item-dialog/edit-audit-picture-item-dialog.module.ts